import { Country } from '~/Api/Country';
import Product from '~/Api/Product/Product';

export enum Type {
	arabEmirates = 'arabEmirates',
	referenced = 'referenced',
	other = 'other',
}

export interface ProductGroup {
	type: Type;
	country: Country | null;
}

export default function resolveAeProductGroup(product: Product, refernceCountries: Country[]): ProductGroup {
	if (product.dataset.source.country.alpha2 === 'AE') {
		return { type: Type.arabEmirates, country: null };
	}
	const country = refernceCountries.find((country) => country.alpha2 === product.dataset.source.country.alpha2);
	if (country !== undefined) {
		return { type: Type.referenced, country };
	}
	return { type: Type.other, country: null };
}
